<script>
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
  export default {
    name: 'select-rd',
    components: {
      'v-select': VueSelect,
    },
    props: ['disabled', 'error', 'label', 'required', 'placeholder', 'options', 'value', 'name'],
    computed: {
      inputVal: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        }
      }
    }
  }
</script>

<template>
    <div class="input-wrapper">
      <label :for="name" v-if="label" class="label-input text-14 fw-500">{{label}}<span v-if="required" class="text-error text-14 fw-500">*</span></label>
      <v-select :placeholder="placeholder" class="vue-select" :class="{error}" :clearable="false" :searchable="false" :options="options" v-model="inputVal" />
      <span class="text-error text-14 fw-300" v-if="error">{{error}}</span>
    </div>
</template>

<style lang="less">
  @import "../../less/redesign/base.less";

  .vue-select .vs__search {
    border-color: transparent !important;
    display: inline-block;
    height: 26px;
    background: none;
    margin-top: 0;
    padding-left: 0;
    &::placeholder {
      color: @grey-input
    }
  }
  .vue-select .vs__dropdown-toggle {
    display: flex;
    padding-top: 7px;
    padding-bottom: 7px;
  }
  .vue-select:hover {
    .vs__actions {
      background-color: @grey-hover;
    }
  }
  .vue-select.error .vs__dropdown-toggle {
    border-color: @secondary-error;
  }
  .vue-select .vs__dropdown-menu {
    margin: 10px 0;
    box-shadow: 0 7px 14px 0 rgba(0,0,0,.11);
    padding: 8px;
    border: 1px solid @grey-input;
    border-radius: 20px;
    & .vs__dropdown-option {
      padding: 10px 16px;
      border-radius: 16px;
      font-weight: 500;
      font-size: 14px;
      margin-bottom: 8px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    & .vs__dropdown-option--highlight {
      background-color: @grey-hover;
      color: @primary-dark;
    }
    & .vs__dropdown-option--selected {
      background-color: @primary-blue;
      color: @primary-light;
    }
  }
  .vue-select.vs--open .vs__dropdown-toggle {
    border-bottom-left-radius: 40px !important;
    border-bottom-right-radius: 40px !important;
    border-color: @primary-blue;
    &:hover {
      border-bottom-color: @secondary-active;
    }
  }
  .vue-select .vs-selected {
    font-size: 16px;
    margin-top: 0;
  }
  .vue-select .vs__actions {
    padding: 0;
    width: 28px;
    height: 28px;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    &:hover {
      background-color: @grey-hover;
    }
  }
</style>



// WEBPACK FOOTER //
// src/ui/select/Select.vue